<template>
  <DashboardPanelTemplate
    :panelSize="panelSize"
    :panelFocus="panelFocus"
    :loading="loading"
    :errorMessage="$t('ErrorMessage')"
  >
    <h4 v-if="hasNotifications">{{ $t('EmptyPanelMainText') }}</h4>
    <dashboard-notifications :loadable="false"></dashboard-notifications>
    <router-link class="view-all" v-if="showViewAll" :to="{ name: notificationsRoute }">View All Notifications</router-link>
  </DashboardPanelTemplate>
</template>
<script>
import DashboardNotifications from '@/components/dashboard/notifications/DashboardNotifications'
import DashboardPanelTemplate from '@/components/layouts/DashboardPanelTemplate'
import NotificationsRoutesEnum from '@/enums/modules/routes/notifications'

export default {
  name: 'NotificationsPanel',
  props: {
    panelSize: {
      type: String,
      required: true
    },
    panelFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    DashboardPanelTemplate,
    DashboardNotifications
  },
  data () {
    return {
      notificationsRoute: NotificationsRoutesEnum.AllNotifications
    }
  },
  mounted () {},
  destroyed () {
    this.$shipBobStore.dispatch('dashboard/notifications/resetNotifications')
  },
  computed: {
    hasNotifications () {
      return this.$shipBobStore.getters['dashboard/notifications/notificationsCount'] > 0
    },
    showViewAll () {
      return !this.$shipBobStore.getters['dashboard/notifications/fetchedAllNotifications'] || this.$shipBobStore.getters['dashboard/notifications/notificationsBuffered'] > 3
      // return this.$shipBobStore.getters['dashboard/notifications/notificationsBuffered'] > 3
    }
  },
  methods: {},
  i18n: {
    messages: {
      'en-US': {
        ErrorMessage: 'Hm... we couldn\'t load your notifications. Please refresh your browser and if you have issues, let our support team know.',
        EmptyPanelMainText: 'Welcome back!'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/../assets/scss/shipbob-custom/components/dashboard/_panel-notifications.scss';
.view-all {
  text-align: center;
  text-decoration: none;
}
</style>